import icon from '@/assets/img/device/amber/icon.png'
import board from '@/assets/img/device/amber/board.png'
import { Amber358 } from './amber358'

export class Amber358Wired extends Amber358 {
  name: string = 'Amber_35_8'
  icon: string = icon
  boardImage: string = board
  width: number = 214
  paddingX: number = 0
  paddingY: number = 0
  paddingBottom: number = 0
  rate: number[] = [0.125, 0.25, 0.5, 1]
}
